export const calendarRouteNames = {
  default: 'calendars-v2',
  calendarPageV2: 'calendars-page-v2',
  appointmentList: 'appointments-list',
  services:'services',
  troubleshootCalendar: 'troubleshoot-calendar',
}